import { API_HOST } from "./config"
export default {
  // FRONT ROUTES
  NAV_SEARCH: `${API_HOST}front/dashboard/search`,
  CLIENT_SEARCH_RESULTS: `${API_HOST}front/dashboard/search_discovery`
}
